import superagent from 'superagent'
import { ROUTE_MEASUREMENT_TYPE } from '../lib/routeDocument'

// Saved Route Builder routes: Measurements with measurementTypeId 2, the same records
// the iOS and Android route builders create (see lib/routeDocument.js for the geoJson).

export const routesSet = routes => ({
  type: 'ROUTES_SET',
  payload: routes
})

export const routeCreate = route => ({
  type: 'ROUTE_CREATE',
  payload: route
})

export const routeUpdate = route => ({
  type: 'ROUTE_UPDATE',
  payload: route
})

export const routeDelete = id => ({
  type: 'ROUTE_DELETE',
  payload: id
})

const send = (req, token) => req
  .set('Authorization', `Bearer ${token}`)
  .set('Content-Type', 'application/json')
  .set('Platform', 'Web')
  .set('Version', `${__version__}`)

// Attach the map-thumbnail photo so My Content (data.photo.thumbnailUrl) shows it,
// as trackUpdateRequest does. A failed photo fetch still keeps the saved route.
const withPhoto = (route, token) => new Promise(resolve => {
  if (!route || !route.photoId) { resolve(route); return }
  send(superagent.get(`${__API_URI__}/photo/get/${route.photoId}`), token)
    .end((err, res) => resolve(err ? route : { ...route, photo: res.body }))
})

// Rejects with the superagent error so the builder can keep the user's work on failure.
export const routeCreateRequest = routeObj => (dispatch, getState, token) => new Promise((resolve, reject) => {
  send(superagent.post(`${__API_URI__}/measurement/create`), token)
    .send(JSON.stringify({ activityId: 1, public: false, ...routeObj, measurementTypeId: ROUTE_MEASUREMENT_TYPE }))
    .end((err, res) => {
      if (err) return reject(err)
      withPhoto(res.body, token).then(route => {
        dispatch(routeCreate(route))
        resolve(route)
      })
    })
})

export const routeUpdateRequest = routeObj => (dispatch, getState, token) => new Promise((resolve, reject) => {
  send(superagent.put(`${__API_URI__}/measurement/update`), token)
    .send(JSON.stringify({ activityId: 1, public: false, ...routeObj, measurementTypeId: ROUTE_MEASUREMENT_TYPE }))
    .end((err, res) => {
      if (err) return reject(err)
      withPhoto(res.body, token).then(route => {
        dispatch(routeUpdate(route))
        resolve(route)
      })
    })
})

// Removed from the store only once the server confirms (as trackDeleteRequest, WEB-7103).
export const routeDeleteRequest = id => (dispatch, getState, token) => new Promise((resolve, reject) => {
  superagent
    .delete(`${__API_URI__}/measurement/delete/${id}`)
    .set('Authorization', `Bearer ${token}`)
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (err) return reject(err)
      dispatch(routeDelete(id))
      resolve(res.body)
    })
})
